<div class="grid grid-cols-1 lg:grid-cols-2 mt-4" tourAnchor="series.dashboard.keyPerformance.widget">
    <div class="lg:pr-7 pl-0">
        <app-base-widget [cardClass]="'bg-white'">
            <mat-tab-group animationDuration="0" (selectedTabChange)="handleChange($event)" [selectedIndex]="1"
                class="key-performance-sm">
                <mat-tab [disabled]="true" class="text-md lg:text-2xl" label="Key P&L Drivers (Quarter to Date)">
                    <ng-template matTabContent></ng-template>
                </mat-tab>
                <mat-tab label={{tabs[1]}}>
                    <ng-template matTabContent>
                        <app-base-widget [card]="false" [error]="keyPerformanceDataForQuarterTop?.error"
                            data-cy="keyPerformanceForQuarterTop">
                            <span class="remaining-value-text">By Gain/(Loss) | Expressed in {{currency()}} (in thousands)</span>
                            <app-gcm-chart [chartData]="keyPerformanceDataForQuarterTop" chartType="bar"
                                [chartStyle]="kdpQuarterChartStyle"
                                [chartOptions]="keyPerformanceQuarterChartOptionsTop()"></app-gcm-chart>
                        </app-base-widget>
                    </ng-template>
                </mat-tab>
                <mat-tab label={{tabs[2]}}>
                    <ng-template matTabContent>
                        <app-base-widget [card]="false" [error]="keyPerformanceDataForQuarterBottom?.error"
                            data-cy="keyPerformanceForQuarterBottom">
                            <span class="remaining-value-text">By Gain/(Loss) | Expressed in {{currency()}} (in thousands)</span>
                            <app-gcm-chart [chartData]="keyPerformanceDataForQuarterBottom" chartType="bar"
                                [chartStyle]="kdpQuarterChartStyle"
                                [chartOptions]="keyPerformanceQuarterChartOptionsBottom()">
                            </app-gcm-chart>
                        </app-base-widget>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </app-base-widget>
    </div>

    <div class="pl-0 mt-4 lg:mt-0 lg:ml-0">
        <app-base-widget [cardClass]="'bg-white'">
            <mat-tab-group animationDuration="0" (selectedTabChange)="handleChange($event)" [selectedIndex]="1"
                class="key-performance-sm">
                <mat-tab [disabled]="true" label="Key P&L Drivers (Inception to Date)">
                    <ng-template matTabContent></ng-template>
                </mat-tab>
                <mat-tab label={{tabs[1]}}>
                    <ng-template matTabContent>
                        <app-base-widget [card]="false" [error]="keyPerformanceDataSinceInceptionTop?.error"
                            data-cy="keyPerformanceSinceInceptionTop">
                            <span class="remaining-value-text">By Gain/(Loss) | Expressed in {{currency()}} (in thousands)</span>
                            <app-gcm-chart [chartData]="keyPerformanceDataSinceInceptionTop" chartType="bar"
                                [chartStyle]="kdpInceptionChartStyle"
                                [chartOptions]="keyPerformanceSinceInceptionChartOptionsTop()">
                            </app-gcm-chart>
                        </app-base-widget>
                    </ng-template>
                </mat-tab>
                <mat-tab label={{tabs[2]}}>
                    <ng-template matTabContent>
                        <app-base-widget [card]="false" [error]="keyPerformanceDataSinceInceptionBottom?.error"
                            data-cy="keyPerformanceSinceInceptionBottom">
                            <span class="remaining-value-text">By Gain/(Loss) | Expressed in {{currency()}} (in thousands)</span>
                            <app-gcm-chart [chartData]="keyPerformanceDataSinceInceptionBottom" chartType="bar"
                                [chartStyle]="kdpInceptionChartStyle"
                                [chartOptions]="keyPerformanceSinceInceptionChartOptionsBottom()">
                            </app-gcm-chart>
                        </app-base-widget>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </app-base-widget>
    </div>
</div>